import { BaseOption, SelectValueType } from 'ui/selects';
import { SelectOption } from 'modules/queryBuilder/contexts/visualComponents';
import { getBaseOptionConverter } from './getBaseOptionConverter';

export const convertOptionsToMappings = <T extends SelectValueType = string>(
  options: SelectOption<T>[],
  isMultiselect?: boolean,
): {
  optionsMapping: Record<string, SelectOption<T>>;
  baseOptionsMapping: Record<string, BaseOption<T>>;
} => {
  const optionsMapping: Record<string, SelectOption<T>> = {};
  const baseOptionsMapping: Record<string, BaseOption<T>> = {};
  const optionConverter = getBaseOptionConverter<T>(!!isMultiselect);
  options.forEach((option) => {
    const baseOption = optionConverter(option);
    baseOptionsMapping[option.value as string] = baseOption;
    optionsMapping[option.value as string] = option;
  });
  return { baseOptionsMapping, optionsMapping };
};
